<app-loading-bar *ngIf="!hasIndicatorsData()" style="text-align: center;margin:40px auto 0 auto;"></app-loading-bar>
<div class="card-painel--table benchmark-table" *ngIf="hasIndicatorsData()">
  <table class="table">
    <thead *ngIf="!hideHeader">
      <tr>
        <th class="" [translate]="'painel-dashboard/indicators'">
          INDICATORS</th>
        <th style="width: 15%;" class="text-right">{{cityName}}</th>
        <th style="width: 10%;" class="text-right img-th">
          <a href="https://blog.brightcities.city{{ (language.current().flag == 'us') ? '/sdgs/' : '/pt-br/agenda2030-ods/' }}"
            [title]="'city-profile/details' | translate" target="_blank">
            <div class="un-logo">
              <img src="./assets/images/logo-un.png" alt="">
            </div>
            {{'painel-dashboard/onu-ods' | translate}}
          </a>
        </th>
        <th style="width: 15%;" class="text-right">
          {{'city-profile-indicators/regional-benchmarking' | translate}}
          <i class="fas fa-info-circle" [matTooltipHideDelay]="300"
            matTooltip="{{'city-profile-indicators/regional-benchmark-description' | translate}}" (click)="tooltip.toggle()" #tooltip="matTooltip"
            matTooltipPosition="above"></i>
        </th>
        <th style="width: 15%;" class="text-right">
          {{'city-profile-indicators/populational-benchmark' | translate}}
          <i class="fas fa-info-circle" [matTooltipHideDelay]="300" matTooltip="
            {{'city-profile-indicators/populational-benchmark-description' | translate}}
            {{'city-profile-indicators/'+getRange(populationRange) | translate}}
            {{'city-profile-indicators/to' | translate}}
            {{cityName}}" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="above"></i>
        </th>
      </tr>
    </thead>
    <tbody *ngIf="!reportData">
      <tr *ngFor="let subArea of subAreas">
        <td colspan="5" class="no-padding">
          <div class="sub-area-heading" (click)="toggleSubArea(subArea)">
            <i class="fas" [ngClass]="{'fa-chevron-up': subArea.show,'fa-chevron-down': !subArea.show}"></i>
            <h2>{{'painel-indicators/' + subArea.code | translate}}</h2>
          </div>
          <table class="table indicators-table" *ngIf="subArea.show">
            <ng-container *ngFor="let item of indicatorsData.indicators; let i = index">
              <tr *ngIf="item.indicator.subArea == subArea.code"
                [ngClass]="{'red-flag': item.indicator.normalizedScore !== null && item.indicator.normalizedScore < 3 && item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled, 'yellow-flag': item.indicator.normalizedScore > 3 && item.indicator.normalizedScore < 5 && item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled}">
                <td [ngStyle]="{width: !hideGlobal ? '55%' : '45%'}">
                  <a (click)="redirIndicator(item.indicator.indicatorId)"
                    class="indicator-link"><span>{{item.indicator.name}}</span></a>
                  <mat-icon class="tooltip-info" matTooltipClass="white-tooltip" [matTooltipHideDelay]="300"
                    matTooltip="{{item.indicator.description}}" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="above">error
                  </mat-icon>
                </td>

                <!-- CITY INDICATORS -->
                <td style="width: 15%;" class="text-right displayed">
                  <div class="cell-content content-horizontal">
                    <ng-container *ngIf="item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled">
                      <mat-icon *ngIf="item.indicator.normalizedScore != null && item.indicator.normalizedScore <= 3" class="mat-error"
                        style="margin-right: 4px" matTooltip="{{'city-profile-indicators/tooltip-error' | translate }}"
                        (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="after" matTooltipClass="error-tooltip">error</mat-icon>
                      <mat-icon *ngIf="item.indicator.normalizedScore > 3 && item.indicator.normalizedScore <= 5"
                        style="margin-right: 4px" class="tooltip-warning"
                        matTooltip="{{'city-profile-indicators/tooltip-warning' | translate }}" (click)="tooltip.toggle()" #tooltip="matTooltip"
                        matTooltipPosition="after" matTooltipClass="tooltip-warning-bg">error</mat-icon>
                    </ng-container>
                    <strong *ngIf="item.indicator.validation === 'ZERO_ONE'">
                      {{ item.indicator.score === null ? '-' : (item.indicator.score === 1 ? ('painel-dashboard/yes' | translate) : ('painel-dashboard/no' | translate)) }}
                    </strong>
                    <span *ngIf="item.indicator.validation != 'ZERO_ONE'">
                      <strong>{{ (item.indicator.score == null) ? "-" : item.indicator.score | number}}</strong>
                      <em *ngIf="item.indicator.score != null && item.unity">{{ item.indicator.unity }}</em>
                    </span>
                  </div>
                </td>

                <!-- ONU ODS -->
                <td style="width: 10%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.indicator.sustainableDevelopmentGoals">
                    <div class="sdg-list">
                      <app-ods-indicator [sdgData]="sdg" *ngFor="let sdg of item.indicator.sustainableDevelopmentGoals">
                      </app-ods-indicator>
                    </div>
                  </div>
                </td>

                <!-- REGIONAL BENCHMARK INDICATORS -->
                <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.regionalBenchmark">
                    <ng-container
                      *ngIf="item.regionalBenchmark.validation != null && item.regionalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.regionalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) :
                      ('painel-dashboard/no' | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.regionalBenchmark.validation != 'ZERO_ONE' || item.regionalBenchmark.score == null">
                      {{((item.regionalBenchmark.score != null) ? item.regionalBenchmark.score : "-") | number}}
                    </ng-container>

                    <em *ngIf="item.regionalBenchmark.cityName">
                      {{item.regionalBenchmark.cityName}}<span *ngIf="item.regionalBenchmark.region">,
                        {{item.regionalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.regionalBenchmark">
                    -
                  </div>
                </td>

                <!-- GLOBAL BENCHMARK INDICATORS -->
                <!-- <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.globalBenchmark">
                    <ng-container
                      *ngIf="item.globalBenchmark.validation != null && item.globalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.globalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) : ('painel-dashboard/no'
                      | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.globalBenchmark.validation != 'ZERO_ONE' || item.globalBenchmark.score == null">
                      {{ ((item.globalBenchmark.score != null) ? item.globalBenchmark.score : "-") | number}}
                    </ng-container>

                    <em *ngIf="item.globalBenchmark && item.globalBenchmark.cityName">
                      {{item.globalBenchmark.cityName}}<span *ngIf="item.globalBenchmark.region">,
                        {{item.globalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.globalBenchmark">
                    -
                  </div>
                </td> -->

                <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.populationalBenchmark">
                    <ng-container
                      *ngIf="item.populationalBenchmark.validation != null && item.populationalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.populationalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) :
                      ('painel-dashboard/no' | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.populationalBenchmark.validation != 'ZERO_ONE' || item.populationalBenchmark.score == null">
                      {{ ((item.populationalBenchmark.score != null) ? item.populationalBenchmark.score : "-") |
                      number}}
                    </ng-container>

                    <em *ngIf="item.populationalBenchmark && item.populationalBenchmark.cityName">
                      {{item.populationalBenchmark.cityName}}<span *ngIf="item.populationalBenchmark.region">,
                        {{item.populationalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.populationalBenchmark">
                    -
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </td>
      </tr>
    </tbody>
    <tbody *ngIf="reportData">
      <tr *ngFor="let subArea of reportData">
        <td colspan="5" class="no-padding">
          <div class="sub-area-heading" (click)="toggleSubArea(subArea)">
            <i class="fas" [ngClass]="{'fa-chevron-up': subArea.show,'fa-chevron-down': !subArea.show}"></i>
            <h2>{{'painel-indicators/' + subArea.code | translate}}</h2>
          </div>
          <table class="table indicators-table" *ngIf="subArea.show">
            <ng-container *ngFor="let item of subArea.indicators; let i = index">
              <tr
                [ngClass]="{'red-flag': item.indicator.normalizedScore < 3 && item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled, 'yellow-flag': item.indicator.normalizedScore > 3 && item.indicator.normalizedScore < 5 && item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled}">
                <td [ngStyle]="{width: !hideGlobal ? '55%' : '45%'}">
                  <a (click)="redirIndicator(item.indicator.indicatorId)"
                    class="indicator-link"><span>{{item.indicator.name}}</span></a>
                  <mat-icon class="tooltip-info" matTooltipClass="white-tooltip" [matTooltipHideDelay]="300"
                    matTooltip="{{item.indicator.description}}" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="above">error
                  </mat-icon>
                </td>

                <!-- CITY INDICATORS -->
                <td style="width: 15%;" class="text-right displayed">
                  <div class="cell-content content-horizontal">
                    <ng-container *ngIf="item.indicator.validation != 'ZERO_ONE' && item.indicator.alertEnabled">
                      <mat-icon *ngIf="item.indicator.normalizedScore <= 3" class="mat-error" style="margin-right: 4px"
                        matTooltip="{{'city-profile-indicators/tooltip-error' | translate }}" (click)="tooltip.toggle()" #tooltip="matTooltip"
                        matTooltipPosition="after" matTooltipClass="error-tooltip">error</mat-icon>
                      <mat-icon *ngIf="item.indicator.normalizedScore > 3 && item.indicator.normalizedScore <= 5"
                        style="margin-right: 4px" class="tooltip-warning"
                        matTooltip="{{'city-profile-indicators/tooltip-warning' | translate }}" (click)="tooltip.toggle()" #tooltip="matTooltip"
                        matTooltipPosition="after" matTooltipClass="tooltip-warning-bg">error</mat-icon>
                    </ng-container>
                    <strong *ngIf="item.indicator.validation == 'ZERO_ONE'">{{ item.indicator.score == 1 ?
                      ('painel-dashboard/yes' | translate) : ('painel-dashboard/no' | translate) }}</strong>
                    <span>
                      <strong *ngIf="item.indicator.validation != 'ZERO_ONE'">{{item.indicator.score | number}}</strong>
                      <em *ngIf="item.unity">{{ item.indicator.unity }}</em>
                    </span>
                  </div>
                </td>

                <!-- ONU ODS -->
                <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.indicator.sustainableDevelopmentGoals">
                    <div class="sdg-list">
                      <app-ods-indicator [sdgData]="sdg" *ngFor="let sdg of item.indicator.sustainableDevelopmentGoals">
                      </app-ods-indicator>
                    </div>
                  </div>
                </td>

                <!-- REGIONAL BENCHMARK INDICATORS -->
                <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.regionalBenchmark">
                    <ng-container
                      *ngIf="item.regionalBenchmark.validation != null && item.regionalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.regionalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) :
                      ('painel-dashboard/no' | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.regionalBenchmark.validation != 'ZERO_ONE' || item.regionalBenchmark.score == null">
                      {{((item.regionalBenchmark.score != null) ? item.regionalBenchmark.score : "-") | number}}
                    </ng-container>

                    <em *ngIf="item.regionalBenchmark.cityName">
                      {{item.regionalBenchmark.cityName}}<span *ngIf="item.regionalBenchmark.region">,
                        {{item.regionalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.regionalBenchmark">
                    -
                  </div>
                </td>

                <!-- GLOBAL BENCHMARK INDICATORS -->
                <!-- <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.globalBenchmark">
                    <ng-container
                      *ngIf="item.globalBenchmark.validation != null && item.globalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.globalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) : ('painel-dashboard/no'
                      | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.globalBenchmark.validation != 'ZERO_ONE' || item.globalBenchmark.score == null">
                      {{ ((item.globalBenchmark.score != null) ? item.globalBenchmark.score : "-") | number}}
                    </ng-container>

                    <em *ngIf="item.globalBenchmark && item.globalBenchmark.cityName">
                      {{item.globalBenchmark.cityName}}<span *ngIf="item.globalBenchmark.region">,
                        {{item.globalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.globalBenchmark">
                    -
                  </div>
                </td> -->

                <td style="width: 15%;" class="text-right hover-edit">
                  <div class="cell-content" *ngIf="item.populationalBenchmark">
                    <ng-container
                      *ngIf="item.populationalBenchmark.validation != null && item.populationalBenchmark.validation == 'ZERO_ONE'">
                      {{ item.populationalBenchmark.score == 1 ? ('painel-dashboard/yes' | translate) :
                      ('painel-dashboard/no' | translate) }}
                    </ng-container>

                    <ng-container
                      *ngIf="item.populationalBenchmark.validation != 'ZERO_ONE' || item.populationalBenchmark.score == null">
                      {{ ((item.populationalBenchmark.score != null) ? item.populationalBenchmark.score : "-") |
                      number}}
                    </ng-container>

                    <em *ngIf="item.populationalBenchmark && item.populationalBenchmark.cityName">
                      {{item.populationalBenchmark.cityName}}<span *ngIf="item.populationalBenchmark.region">,
                        {{item.populationalBenchmark.region}}</span>
                    </em>
                  </div>

                  <div class="cell-content" *ngIf="!item.populationalBenchmark">
                    -
                  </div>
                </td>
              </tr>
            </ng-container>
          </table>
        </td>
      </tr>
    </tbody>
  </table>
</div>
